module.exports = __webpack_public_path__ + "static/bg05-0eeb43e54d3eb1b020468a0df7c1341b.jpg";